import React, { useState, useEffect } from 'react';
import '../assets/profilePersonalOptionHeader.css';
import { ChevronLeft } from 'lucide-react';
import useMobileSize from '../../goldTrading/hooks/useMobileSize';
import { profileMenuDescktop } from '../constant/profileMenuDescktop';
import ProfilePersonalHeader from './ProfilePersonalHeader';
import ProfilePersonalHeaderDescktop from './ProfilePersonalHeaderDescktop';
import { ResponsiveModal } from './logout/ResponsiveModal';
import { set_user } from '../../../actions/user';
import { ResponsiveModalDesck } from './logout/ResponsiveModalDesck';

const ProfileOptionHeaderDescktop = () => {
  const isMobile = useMobileSize({ type: 'AdvancedSearch' });
  const [currentPath, setCurrentPath] = useState('');
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false); // تصحیح نام state

  useEffect(() => {
    // تنظیم path فعلی
    setCurrentPath(window.location.pathname);

    // Listen کردن به تغییرات URL
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    // برای تشخیص تغییراتی که با history API انجام می‌شه
    window.addEventListener('popstate', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);

  // تابع برای چک کردن اینکه آیا لینک اکتیو هست یا نه
  const isActiveLink = (link) => {
    if (!link) return false;

    // اگر link مطابق با currentPath باشه
    if (currentPath === link) return true;

    // اگر در صفحه اصلی هستیم و link هم '/' باشه
    if (currentPath === '/' && link === '/') return true;

    // برای sub-routes (مثلاً /profile/settings در /profile اکتیو باشه)
    if (link !== '/' && currentPath.startsWith(link)) return true;

    return false;
  };

  return (
    <>
      <div className={isMobile ? 'container-optionHeader' : 'container-optionHeader-desktop'} style={{ width: '300px' }}>
        <ProfilePersonalHeaderDescktop />
        {profileMenuDescktop.map((item) =>
          item.title !== 'خروج' ? (
            <a key={item.id} className={`menuItem-optionHeader ${isActiveLink(item.link) ? 'menuItem-optionHeader-active' : ''}`} onClick={item.onClick} href={item.link}>
              <div className={'leftSide-optionHeader'}>
                <ChevronLeft size={16} className={`chevronIcon ${isActiveLink(item.link) ? 'chevronIcon-active' : ''}`} />
              </div>

              <div className={'rightSide-optionHeader'}>
                <div className={`iconContainer-optionHeader ${isActiveLink(item.link) ? 'iconContainer-optionHeader-active' : ''}`}>{item.icon}</div>
                <span className={`title-optionHeader ${isActiveLink(item.link) ? 'title-optionHeader-active' : ''}`}>{item.title}</span>
              </div>
            </a>
          ) : (
            <div
              key={item.id}
              className={`menuItem-optionHeader ${isActiveLink(item.link) ? 'menuItem-optionHeader-active' : ''}`}
              onClick={() => {
                if (item.title === 'خروج') setIsLogoutModalOpen(true);
              }}
            >
              <div className={'leftSide-optionHeader'}>
                <ChevronLeft size={16} className={`chevronIcon ${isActiveLink(item.link) ? 'chevronIcon-active' : ''}`} />
              </div>

              <div className={'rightSide-optionHeader'}>
                <div className={`iconContainer-optionHeader ${isActiveLink(item.link) ? 'iconContainer-optionHeader-active' : ''}`}>{item.icon}</div>
                <span className={`title-optionHeader ${isActiveLink(item.link) ? 'title-optionHeader-active' : ''}`}>{item.title}</span>
              </div>
            </div>
          ),
        )}
      </div>
      <ResponsiveModalDesck
        isOpen={isLogoutModalOpen} // تصحیح نام prop
        onClose={() => setIsLogoutModalOpen(false)}
        title='از حساب کاربری خود خارج میشوید؟'
        primaryButtonText='خروج'
        onPrimaryClick={() => {
          localStorage.setItem('token', undefined);
          set_user({});
          window.location.href = '/';
        }}
      >
        <p style={{ fontSize: '11px', fontWeight: '600' }}>با خروج از حساب کاربری، به سبد خرید فعلی‌تان دسترسی نخواهید داشت. </p>

        <p style={{ fontSize: '11px', fontWeight: '600' }}> هروقت بخواهید می‌توانید مجدداً وارد شوید و خریدتان را ادامه دهید.</p>
      </ResponsiveModalDesck>
    </>
  );
};

export default ProfileOptionHeaderDescktop;
